let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hP4MP")).then(() => parcelRequire('dGxBa'));